import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter';

const MonthlyInstallationItem = ({ item }) => {
    return (
        <tr>
            <CustomTd>
                {item.customerName}
            </CustomTd>
            <CustomTd>
                {item.designer}
            </CustomTd>
            <CustomTd>
                {formatter.date(item.installDate)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.jobTotal)}
            </CustomTd>
            <CustomTd>
                {formatter.currency(item.balanceDue)}
            </CustomTd>
            <CustomTd>
                {item.paidInFull ? '✓' : ''}
            </CustomTd>
            <CustomTd>
                {item.leadSource}
            </CustomTd>
            <CustomTd>
                {item.subLeadSource}
            </CustomTd>
            <CustomTd colSpan={2}>
                {item.arNote}
            </CustomTd>
        </tr>
    );
}

export default MonthlyInstallationItem;